<ng-container *ngIf="overview$ | async as overview">
  <ng-container
    *ngIf="
      (overviewIsLoading$ | async) === false && overview.order;
      else isLoading
    ">
    <pw-view-title *ngIf="overview?.order">{{
      overview.order.NAME
    }}</pw-view-title>

    <pw-view-actions>
      <button
        *ngIf="!checkPm(overview?.order)"
        mat-icon-button
        (click)="openSearchDialog()">
        <mat-icon>find_in_page</mat-icon>
      </button>
      <button
        *ngIf="!checkPm(overview?.order)"
        mat-icon-button
        matTooltip="{{
          'orders.ordersOverview.downloadProjectstatus' | translate
        }}"
        (click)="downloadProjectStatusReport(overview.order)">
        <mat-icon>source</mat-icon>
      </button>
      <button
        *ngIf="overviewType === 'pm'"
        mat-icon-button
        matTooltip="{{ 'orders.ordersOverview.multiEdit' | translate }}"
        routerLink="/orders/{{
          activatedRoute.snapshot.params.id
        }}/pm-project-status">
        <mat-icon>edit_calendar</mat-icon>
      </button>
    </pw-view-actions>

    <mat-accordion *ngIf="overview.order && overview.orderStatusIcons">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>{{
            'orders.ordersOverview.orderInformation' | translate
          }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ps-grid-4-col">
          <div>
            {{ 'orders.ordersOverview.description' | translate }}:
            {{ overview.order.DESCRIPTION }}
          </div>
          <div>
            {{ 'orders.ordersOverview.supplier' | translate }}:
            {{ overview.order.LIEFERANT }}
          </div>
          <div>
            {{ 'orders.ordersOverview.project' | translate }}:
            {{ overview.order.PROJEKTNAME }}
          </div>
          <div>
            {{ 'orders.ordersOverview.date' | translate }}:
            {{ overview.order.TERMIN | date }}
          </div>
          <div>
            {{ 'orders.ordersOverview.channel' | translate }}:
            {{ overview.order.CHANNELNAME }}
          </div>
          <div>
            {{ 'orders.ordersOverview.status' | translate }}:
            <img
              src="{{
                overview.orderStatusIcons[overview.order.LIEFERSTATUS_ICON]
              }}" />{{ overview.order.LIEFERSTATUS }}
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-container
      *ngIf="checkPm(overview.order); else tabs"
      class="pos-card-container">
      <div style="display: flex">
        <div style="flex: 1 0 auto"></div>
        <button mat-icon-button (click)="toggleDisplay()">
          <mat-icon *ngIf="!displayAsList; else cardIcon">view_list</mat-icon>
          <ng-template #cardIcon>
            <mat-icon>dashboard</mat-icon>
          </ng-template>
        </button>
      </div>
      <div *ngIf="!displayAsList; else list" class="ps-grid-3-col">
        <ps-position-pm-card
          *ngFor="let pos of overview.pmPositions"
          [pbo]="overview.order"
          (posUpdatedEvent)="reload()"
          [pos]="pos"></ps-position-pm-card>
      </div>
      <ng-template #list>
        <ps-pm-position-list
          [positions]="overview.pmPositions"
          (posChangedEvent)="reload()"></ps-pm-position-list>
      </ng-template>
    </ng-container>

    <ng-template #tabs>
      <mat-tab-group
        *ngIf="checkExternal(overview.order)"
        style="padding-top: 16px"
        (selectedIndexChange)="onSelectedTabChange($event)"
        [selectedIndex]="selectedIndex$ | async">
        <mat-tab
          label="{{ 'orders.ordersOverview.partsDelivery' | translate }}">
          <div class="pos-card-container ps-grid-3-col">
            <ps-position-tl-card
              *ngFor="let pos of overview.tlPositions"
              [pbo]="overview.order"
              (checkChangedEvent)="reload()"
              [pos]="pos"></ps-position-tl-card>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'orders.ordersOverview.tools' | translate }}">
          <div class="pos-card-container ps-grid-3-col">
            <ps-position-bm-card
              *ngFor="let pos of overview.bmPositions"
              [pbo]="overview.order"
              (checkChangedEvent)="reload()"
              [pos]="pos"></ps-position-bm-card>
          </div>
        </mat-tab>
      </mat-tab-group>

      <mat-tab-group
        *ngIf="!checkExternal(overview.order)"
        style="padding-top: 16px"
        (selectedIndexChange)="onSelectedTabChange($event)"
        [selectedIndex]="selectedIndex$ | async">
        <mat-tab
          label="{{ 'orders.ordersOverview.partsProduction' | translate }}">
          <div class="pos-card-container ps-grid-3-col">
            <ps-position-tp-card
              *ngFor="let pos of overview.tpPositions"
              [pbo]="overview.order"
              (checkChangedEvent)="reload()"
              [pos]="pos"></ps-position-tp-card>
          </div>
        </mat-tab>

        <mat-tab label="{{ 'orders.ordersOverview.tools' | translate }}">
          <div class="pos-card-container ps-grid-3-col">
            <ps-position-bm-card
              *ngFor="let pos of overview.bmPositions"
              [pbo]="overview.order"
              (checkChangedEvent)="reload()"
              [pos]="pos"></ps-position-bm-card>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-template>
  </ng-container>

  <ng-template #isLoading>
    {{ 'orders.ordersOverview.loadingOverview' | translate }}
  </ng-template>
</ng-container>
